angular.module('galilai.creator').controller('HelpController', function ($timeout, $scope, $rootScope) {

    $scope.groups = [
        {
            "name": "Primeiros Passos",
            "id": "getting-started",
            "items": [
                { "name": "Criação de Posts", "id": "create-posts", "url": "https://www.youtube.com/watch?v=i1Rha8bMV3E&list=PL5-lev0bfNrSx2dMuseENTvW6U0I6o_Wb" },
                { "name": "Edição de Posts", "id": "edit-posts", "url": "https://www.youtube.com/watch?v=u7-KiNTaSPQ&list=PL5-lev0bfNrSx2dMuseENTvW6U0I6o_Wb&index=2" },
                { "name": "Identidade Visual", "id": "visual-identity", "url": "https://www.youtube.com/watch?v=k3xGWltZT0M&list=PL5-lev0bfNrSx2dMuseENTvW6U0I6o_Wb&index=3" },
                { "name": "Publicação e Download de Posts", "id": "publish-download-posts", "url": "https://www.youtube.com/watch?v=5xPxEjv7j58&list=PL5-lev0bfNrSx2dMuseENTvW6U0I6o_Wb&index=4" }
            ]
        },
        {
            "name": "Geração de Posts",
            "id": "generate",
            "items": [
                { "name": "Posts com meus Assuntos", "id": "themes", "url": "https://www.youtube.com/watch?v=6u_LXvjCUeE&list=PL5-lev0bfNrRlO2LkGfOpK-AXviu0LGrS&index=1" },
                { "name": "Escrever o que eu preciso", "id": "instruction", "url": "https://www.youtube.com/watch?v=tHA3mFXjhuY&list=PL5-lev0bfNrRlO2LkGfOpK-AXviu0LGrS&index=2" },
                { "name": "Posts de Produtos e Serviços", "id": "product", "url": "https://www.youtube.com/watch?v=Z5f_6Ezf5yw&list=PL5-lev0bfNrRlO2LkGfOpK-AXviu0LGrS&index=3" },
                { "name": "Posts a partir de Imagens", "id": "media", "url": "https://www.youtube.com/watch?v=W3y5N1Bwphk&list=PL5-lev0bfNrRlO2LkGfOpK-AXviu0LGrS&index=4" },
                { "name": "Formatos", "id": "formats", "url": "https://www.youtube.com/watch?v=tQYC-WvPt54&list=PL5-lev0bfNrRlO2LkGfOpK-AXviu0LGrS&index=5" },
                { "name": "Configurações avançadas", "id": "advanced-settings", "url": "https://www.youtube.com/watch?v=mLEG7_hLAiM&list=PL5-lev0bfNrRlO2LkGfOpK-AXviu0LGrS&index=6" },
                { "name": "Posts a partir de Links, Blogs, e Sites", "id": "link", "url": "https://www.youtube.com/watch?v=ck2zzWQheeo&list=PL5-lev0bfNrRlO2LkGfOpK-AXviu0LGrS&index=7" },
                { "name": "Datas Comemorativas", "id": "dates", "url": "https://www.youtube.com/watch?v=C4eIDKNRIQw&list=PL5-lev0bfNrRlO2LkGfOpK-AXviu0LGrS&index=8" },
                { "name": "Posts Prontos de outras ferramentas", "id": "existing", "url": "https://www.youtube.com/watch?v=jfW01DmGK0g&list=PL5-lev0bfNrRlO2LkGfOpK-AXviu0LGrS&index=9" },
                { "name": "Post em Branco", "id": "empty", "url": "https://www.youtube.com/watch?v=G6VU2c4WEbs&list=PL5-lev0bfNrRlO2LkGfOpK-AXviu0LGrS&index=10" },
                { "name": "Idioma dos Posts", "id": "post-language", "url": "https://www.youtube.com/watch?v=j_Qc6xjhNZ8&list=PL5-lev0bfNrRlO2LkGfOpK-AXviu0LGrS&index=11" }
            ]
        },
        {
            "name": "Edição dos Posts",
            "id": "editing",
            "items": [
                { "name": "Acessando a Edição do post", "id": "access-post-edit", "url": "https://www.youtube.com/watch?v=PcNBKmuzMDc&list=PL5-lev0bfNrRTrOAp1G9D9L1TN7xCgFX4" },
                { "name": "Visão Geral da Edição", "id": "edit-overview", "url": "https://www.youtube.com/watch?v=1O_SyB1B9iE&list=PL5-lev0bfNrRTrOAp1G9D9L1TN7xCgFX4&index=2" },
                { "name": "Edição de Textos", "id": "text-editing", "url": "https://www.youtube.com/watch?v=V_x_QGx623o&list=PL5-lev0bfNrRTrOAp1G9D9L1TN7xCgFX4&index=3" },
                { "name": "Edição dos Layouts", "id": "layout-editing", "url": "https://www.youtube.com/watch?v=_pef4LmSIVk&list=PL5-lev0bfNrRTrOAp1G9D9L1TN7xCgFX4&index=4" },
                { "name": "Edição de Imagens", "id": "image-editing", "url": "https://www.youtube.com/watch?v=w2y5V6NF7WQ&list=PL5-lev0bfNrRTrOAp1G9D9L1TN7xCgFX4&index=5" },
                { "name": "Criando e Editando Reels", "id": "create-edit-reels", "url": "https://www.youtube.com/watch?v=XXGuJoYlrlM&list=PL5-lev0bfNrRTrOAp1G9D9L1TN7xCgFX4&index=6" },
                { "name": "Usando Vídeos", "id": "using-videos", "url": "https://www.youtube.com/watch?v=PHT3bOzg8oQ&list=PL5-lev0bfNrRTrOAp1G9D9L1TN7xCgFX4&index=7" },
                { "name": "Escolhendo Músicas", "id": "choose-music", "url": "https://www.youtube.com/watch?v=Ltco40-aAXs&list=PL5-lev0bfNrRTrOAp1G9D9L1TN7xCgFX4&index=8" },
                { "name": "Formato e Tamanho do Post", "id": "post-size-format", "url": "https://www.youtube.com/watch?v=PX07cNkidc4&list=PL5-lev0bfNrRTrOAp1G9D9L1TN7xCgFX4&index=9" },
                { "name": "Editor Visual e Edições avançadas", "id": "visual-editor-advanced", "url": "https://www.youtube.com/watch?v=fUC3-XUvI8k&list=PL5-lev0bfNrRTrOAp1G9D9L1TN7xCgFX4&index=10" },
                { "name": "Estilos de Posts, Página e Elementos", "id": "styles-page-elements", "url": "https://www.youtube.com/watch?v=AdEUTAYJAI8&list=PL5-lev0bfNrRTrOAp1G9D9L1TN7xCgFX4&index=11" },
                { "name": "Cores dos Posts", "id": "post-colors", "url": "https://www.youtube.com/watch?v=Tzeoj6DFqWI&list=PL5-lev0bfNrRTrOAp1G9D9L1TN7xCgFX4&index=12" },
                { "name": "Personalizando Fontes", "id": "custom-fonts", "url": "https://www.youtube.com/watch?v=NJ0GRlzTAfg&list=PL5-lev0bfNrRTrOAp1G9D9L1TN7xCgFX4&index=13" },
                { "name": "Tamanho dos Textos", "id": "text-size", "url": "https://www.youtube.com/watch?v=Lh1v1e6I0Dg&list=PL5-lev0bfNrRTrOAp1G9D9L1TN7xCgFX4&index=14" }
            ]
        },
        {
            "name": "Publicação de Posts",
            "id": "publishing",
            "items": [
                { "name": "Criando Legendas", "id": "create-captions", "url": "https://www.youtube.com/watch?v=DPM0gQ9y3iY&list=PL5-lev0bfNrTl2-KDVPfN-_NWVBVh-mgK" },
                { "name": "Conectando suas Contas do Instagram/Facebook", "id": "connect-accounts", "url": "https://www.youtube.com/watch?v=jTakCvsk8ac&list=PL5-lev0bfNrTl2-KDVPfN-_NWVBVh-mgK&index=2" },
                { "name": "Agendamento e Publicação", "id": "schedule-publish", "url": "https://www.youtube.com/watch?v=Qg4fY06IkHc&list=PL5-lev0bfNrTl2-KDVPfN-_NWVBVh-mgK&index=3" },
                { "name": "Download dos Posts", "id": "download-posts", "url": "https://www.youtube.com/watch?v=6lpUCdLukag&list=PL5-lev0bfNrTl2-KDVPfN-_NWVBVh-mgK&index=4" },
                { "name": "Pré-visualizar Posts", "id": "preview-posts", "url": "https://www.youtube.com/watch?v=wUGJceT9B9E&list=PL5-lev0bfNrTl2-KDVPfN-_NWVBVh-mgK&index=5" }
            ]
        },

        {
            "name": "Identidade Visual",
            "id": "branding",
            "items": [
                { "name": "Hierarquia de Estilos", "id": "style-hierarchy", "url": "https://www.youtube.com/watch?v=k3xGWltZT0M&list=PL5-lev0bfNrQXHi7K6X_iOZWxI7mmiMhR&index=1" },
                { "name": "Editando Cores", "id": "edit-colors", "url": "https://www.youtube.com/watch?v=TAFpvXKD_Qk&list=PL5-lev0bfNrQXHi7K6X_iOZWxI7mmiMhR&index=2" },
                { "name": "Enviando Minha Logo", "id": "upload-logo", "url": "https://www.youtube.com/watch?v=iZvrdMJVbcg&list=PL5-lev0bfNrQXHi7K6X_iOZWxI7mmiMhR&index=1" },
                { "name": "Escolhendo e Enviando Fontes", "id": "upload-fonts", "url": "https://www.youtube.com/watch?v=lcYhMRbFc14&list=PL5-lev0bfNrQXHi7K6X_iOZWxI7mmiMhR&index=2" },
                { "name": "Editando meu Perfil", "id": "edit-profile", "url": "https://www.youtube.com/watch?v=FRLnbIsnb6w&list=PL5-lev0bfNrQXHi7K6X_iOZWxI7mmiMhR&index=3" }
            ]
        },
        {
            "name": "Gestão dos Meus Posts",
            "id": "manage",
            "items": [
                { "name": "Meus Posts e Modos de Visualização", "id": "my-posts-views", "url": "https://www.youtube.com/watch?v=gGgeRHTCF9g&list=PL5-lev0bfNrTy5wPkT0Pwbdv1UceKofaA&index=1" },
                { "name": "Criação de Posts e Atalhos rápidos de Geração", "id": "quick-post-generation", "url": "https://www.youtube.com/watch?v=7hU4EAgY1oc&list=PL5-lev0bfNrTy5wPkT0Pwbdv1UceKofaA&index=2" },
                { "name": "Acessando tela Edição de Posts", "id": "access-edit-screen", "url": "https://www.youtube.com/watch?v=0d4va_GIlVY&list=PL5-lev0bfNrTy5wPkT0Pwbdv1UceKofaA&index=3" },
                { "name": "Agendamento, Download e Status dos Posts", "id": "schedule-download-status", "url": "https://www.youtube.com/watch?v=sfXWmJ_ru3Y&list=PL5-lev0bfNrTy5wPkT0Pwbdv1UceKofaA&index=4" },
                { "name": "Calendário e Planejamento de Posts", "id": "calendar-post-planning", "url": "https://www.youtube.com/watch?v=Ii7RZxC2ork&list=PL5-lev0bfNrTy5wPkT0Pwbdv1UceKofaA&index=5" },
                { "name": "Múltiplas Contas", "id": "multiple-accounts", "url": "https://www.youtube.com/watch?v=w02Q1ouWFok&list=PL5-lev0bfNrTy5wPkT0Pwbdv1UceKofaA&index=6" },
                { "name": "Removendo Posts", "id": "remove-posts", "url": "https://www.youtube.com/watch?v=spTjtnnOx4s&list=PL5-lev0bfNrTy5wPkT0Pwbdv1UceKofaA&index=7" }
            ]
        },
    ]


    $scope.activeGroup = $scope.groups[0];
    $scope.searchQueryRaw = '';
    $scope.searchQuery = '';
    $scope.filteredItems = [];

    $scope.setActiveGroup = function (group) {
        $scope.activeGroup = group;
    };

    // Normalize text (remove diacritics, lowercase)
    function normalize(text) {
        if (!text) return '';
        return text
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
    }

    var searchTimeout;
    $scope.debouncedSearch = function () {
        $scope.showByIds = null; // Clear any specific item view
        if (searchTimeout) $timeout.cancel(searchTimeout);
        searchTimeout = $timeout(function () {
            $scope.searchQuery = $scope.searchQueryRaw;
            applyFilter();
        }, 300); // 300ms debounce
    };

    function applyFilter() {
        var q = normalize($scope.searchQuery);
        if (!q) {
            $scope.filteredItems = [];
            return;
        }

        var results = [];
        $scope.groups.forEach(function (group) {
            group.items.forEach(function (item) {
                if (normalize(item.name).indexOf(q) !== -1) {
                    var copy = angular.copy(item);
                    copy.groupName = group.name; // add group name
                    results.push(copy);
                }
            });
        });

        $scope.filteredItems = results;
    }

    $scope.clearSearch = function () {
        $scope.searchQueryRaw = '';
        $scope.searchQuery = '';
        $scope.filteredItems = [];
    };

    $scope.showByIds = null;
    $scope.clearShowByIds = function () {
        $scope.showByIds = null;
    };

    $scope.$on('help.show', function (event, data) {
        // Reset all modes
        $scope.activeGroup = null;
        $scope.searchQueryRaw = '';
        $scope.searchQuery = '';
        $scope.filteredItems = [];
        $scope.showByIds = null;
        $scope.clearSearch();

        if (data.id) {
            // Open specific help link
            var found = null;
            $scope.groups.forEach(function (group) {
                group.items.forEach(function (item) {
                    if (item.id === data.id) found = item;
                });
            });
            if (found && found.url) window.open(found.url, '_blank');

        } else if (data.group) {
            // Show modal with group
            var match = $scope.groups.find(function (g) { return g.id === data.group; });
            if (match) {
                $scope.activeGroup = match;
                $scope.clearSearch();
                $scope.showByIds = null;

                setTimeout(function () {
                    var modal = new bootstrap.Modal(document.getElementById('help-modal'));
                    modal.show();
                }, 50);
            }

        } else if (data.ids && Array.isArray(data.ids)) {
            // Show only specific items by IDs
            var foundItems = [];
            $scope.groups.forEach(function (group) {
                group.items.forEach(function (item) {
                    if (data.ids.includes(item.id)) {
                        var copy = angular.copy(item);
                        copy.groupName = group.name;
                        foundItems.push(copy);
                    }
                });
            });

            $scope.showByIds = foundItems;
            $scope.clearSearch();

            setTimeout(function () {
                var modal = new bootstrap.Modal(document.getElementById('help-modal'));
                modal.show();
            }, 50);
        }
    });

})